import { createUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IMenuList } from '~/src/dash/types/menuList';

export interface IasFilter {
  ID: string;
  title: string;
  selected: boolean;
  values: string[];
}

export const genIasDeviceFiltersList = (): IasFilter[] => {
  return [
    {
      ID: 'Desktop',
      title: 'Desktop',
      selected: false,
      values: ['desktop'],
    },
    {
      ID: 'Mobile',
      title: 'Mobile',
      selected: false,
      values: ['mobileWeb', 'mobileApp'],
    },
    {
      ID: 'Tablet',
      title: 'Tablet',
      selected: false,
      values: ['tabletWeb', 'tabletApp'],
    },
    {
      ID: 'Connected TV',
      title: 'Connected TV',
      selected: false,
      values: ['ctv'],
    },
  ];
};

export const genIasMediaFormatFiltersList = (): IasFilter[] => {
  return [
    {
      ID: 'display',
      title: 'Display',
      selected: false,
      values: ['display'],
    },
    {
      ID: 'video',
      title: 'Video',
      selected: false,
      values: ['video'],
    },
  ];
};

export async function getIasFilterOptionsList(
  session: ISessionState,
  key: string,
  startDate: moment.Moment,
  endDate: moment.Moment,
  search?: string,
): Promise<Record<string, IMenuList>> {
  let reqURL =
    `${createUrl('/ias_filter_options', session.publisher.ID, 'v1')}` +
    `&key=${key}` +
    `&start_date=${startDate.format('YYYY-MM-DD')}` +
    `&end_date=${endDate.format('YYYY-MM-DD')}`;

  if (!!search && search !== '') {
    reqURL = reqURL + `&q=(${search})`;
  }

  return await restGet<any>(reqURL, {})
    .then((val: IHttpResponse<any>) => {
      const data = val.parsedBody.pubViewability;

      const ret = {
        [key]: data.reduce((currMenuList: IMenuList, filterDatum: any) => {
          const dimensionFilterData = Object.values(filterDatum) as string[];
          const ID = dimensionFilterData[0];
          currMenuList[ID] = {
            ID,
            title: dimensionFilterData[1],
            selected: false,
          };
          return currMenuList;
        }, {}),
      };

      return ret;
    })
    .catch((e) => {
      console.error(e);
      return {
        [key]: {},
      };
    });
}
